<template>
  <main>
    <img
      class="shop mb-2"
      width="96"
      src="@/assets/shop-car.png">
    <br>
    <div>
      <span>支付确认中，请稍候</span><span class="ellipsis">......</span>
    </div>
    <!-- <div class="ellipsis">......</div> -->
  </main>
</template>

<script>
// description: 支付完成后跳转页, 用于等待确定订单已经完成支付
// author: xiemm

export default {
  name: 'Verify',
  components: {},
  data() {
    return {
      timer: 0,
    };
  },
  activated() {
    this.timer = 6;
    this.verify();
  },
  mounted() {
    this.timer = 6;
    this.verify();
  },
  methods: {
    // 测试订单状态
    async handleLoad() {
      const billCode = this.$route.params.id;
      if (billCode.slice(0, 2) === 'MY') {
        const response = await this.$http.get('/cloud-film-api/webapi/order/get-by-user', {
          orderId: billCode,
        });
        return response.order_status;
      }
      const response = await this.$http.get('/cloud-film-api/webapi/bill/get-bill', {
        bill_code: billCode,
      });
      return response.bill_status;
    },
    async verify() {
      if (this.timer > 0) {
        const self = this;
        this.timer -= 1;
        setTimeout(async () => {
          const status = await this.handleLoad();
          if (status === '等待支付') {
            self.verify();
          } else {
            self.$router.push({ name: 'order-detail', params: { id: this.$route.params.id } });
          }
        }, 1000);
      } else {
        this.$router.push({ name: 'order-detail', params: { id: this.$route.params.id } });
      }
    },
  },
};
</script>

<style scoped>
</style>

<style lang="scss" scoped>
  main {
    color: gray;
    text-align: center;
    div {
      text-align: left;
      padding-left: calc(50% - 70px);
    }
  }
  .shop {
    margin-top: 90px;
  }

  .ellipsis {
    display: inline-block;
    overflow: hidden;
    text-align: left;
    animation: loading 2s infinite;
  }

  @keyframes loading {
    from { width: 0px; }
    to { width: 24px }
  }
</style>
